import React, { useMemo, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { X } from "react-feather";
import { toast } from "react-toastify";
import Lightbox from "yet-another-react-lightbox";

import { baseUrl } from "services/api";
import { deleteSupplyProductDocument } from "services/apiSupply";
import { getSupplyProductImageFiles } from "../supplyProductFiles";
import { CloseButton } from "components/CloseButton";

import "yet-another-react-lightbox/dist/styles.css";

import "./supplyAllPhotosModal.scss";

export const SupplyAllPhotosModal = ({
  isOpen,
  toggle,
  supplyId,
  products,
  setProducts,
  setLoading,
}) => {
  const [gallery, setGallery] = useState({ open: false, index: 0 });

  const items = useMemo(() => {
    const out = [];
    for (const p of products || []) {
      for (const f of getSupplyProductImageFiles(p)) {
        out.push({
          productId: p.id,
          rowIndex: p.index,
          brand: p.brand || p.nomenclature?.brand || "",
          article: p.article,
          name: p.name,
          key: f.key,
          fileName: f.name,
          src: `${baseUrl}/image.view?file=${encodeURIComponent(f.key)}`,
        });
      }
    }
    return out;
  }, [products]);

  const slides = useMemo(
    () =>
      items.map((it) => ({
        src: it.src,
        alt: it.fileName || it.name || `№${it.rowIndex}`,
      })),
    [items]
  );

  const openGalleryAt = (index) => {
    if (!slides.length) return;
    setGallery({ open: true, index });
  };

  const removeHandler = (productId, key) => {
    if (!window.confirm("Удалить это изображение?")) return;
    setLoading(true);
    deleteSupplyProductDocument(supplyId, productId, key)
      .then((res) => {
        setProducts(res);
        toast.success("Файл удалён");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message || "Ошибка удаления");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" className="supply-all-photos-modal">
      <ModalHeader>
        <div className="modal-title-text">Изображения по поступлению</div>
        <CloseButton onClick={toggle} />
      </ModalHeader>
      <ModalBody>
        {items.length === 0 ? (
          <p className="text-muted mb-0">Нет прикреплённых изображений.</p>
        ) : (
          <div className="supply-all-photos-modal__grid">
            {items.map((item, index) => (
              <div key={`${item.productId}-${item.key}`} className="supply-all-photos-modal__card">
                <div className="supply-all-photos-modal__thumb">
                  <button
                    type="button"
                    className="supply-all-photos-modal__remove-thumb"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeHandler(item.productId, item.key);
                    }}
                    title="Удалить"
                    aria-label="Удалить изображение"
                  >
                    <X size={15} strokeWidth={2.5} />
                  </button>
                  <button
                    type="button"
                    className="supply-all-photos-modal__thumb-open"
                    onClick={() => openGalleryAt(index)}
                    title="Открыть просмотр"
                    aria-label="Открыть изображение в полном размере"
                  >
                    <img src={item.src} alt={item.fileName || ""} loading="lazy" />
                  </button>
                </div>
                <div className="supply-all-photos-modal__meta">
                  <span className="supply-all-photos-modal__line">
                    №{item.rowIndex}
                    {item.brand ? ` · ${item.brand}` : ""}
                    {item.article ? ` · ${item.article}` : ""}
                  </span>
                  {item.name && (
                    <span className="supply-all-photos-modal__line supply-all-photos-modal__line--muted">
                      {item.name}
                    </span>
                  )}
                  {item.fileName && (
                    <span className="supply-all-photos-modal__line supply-all-photos-modal__line--muted">
                      {item.fileName}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Закрыть
        </Button>
      </ModalFooter>

      <Lightbox
        open={gallery.open}
        close={() => setGallery((s) => ({ ...s, open: false }))}
        index={gallery.index}
        slides={slides}
        on={{
          view: ({ index: i }) => setGallery((s) => ({ ...s, index: i })),
        }}
      />
    </Modal>
  );
};
